import { observer } from 'mobx-react'
import React from 'react'
import { InfoBubble } from '../misc/InfoBubble'
import { Table, TableBody, TableHeader, TableHeaderH } from '../misc/table'
import { FeatureSwitchButton } from './FeatureSwitchButton'
import { FeatureSwitchName } from './FeatureSwitches'

export const GlobalFeatureSwitches = observer(({ featureSwitchesSlice }) => {
  const {
    globalFeatureSwitches,
    fsDescriptions,
    toggleGlobalFeatureSwitch
  } = featureSwitchesSlice

  const toggleFeatureSwitch = ({ featureSwitch, value }) => {
    toggleGlobalFeatureSwitch(featureSwitch, value)
  }

  return (
    <div>
      <h2>Global feature switches</h2>
      {Object.keys(globalFeatureSwitches).length > 0 &&
        <Table>
          <TableHeader>
            <tr>
              <TableHeaderH>Feature switch</TableHeaderH>
              <TableHeaderH/>
            </tr>
          </TableHeader>
          <TableBody>
            {
              Object.entries(globalFeatureSwitches).map(([fsName, fsValue]) => (
                <tr key={fsName}>
                  <td>
                    <FeatureSwitchName name={fsName}/>
                    <InfoBubble content={fsDescriptions[fsName]} id={fsName}/>
                  </td>
                  <td>
                    <FeatureSwitchButton
                      featureSwitch={fsName}
                      on={fsValue}
                      onClick={toggleFeatureSwitch}
                      type="global"
                    />
                  </td>
                </tr>
              ))
            }
          </TableBody>
        </Table>
      }
    </div>
  )
})
